// 말소 셸 정산 탭 (B4 W2) — /main/m/ledger · 전체 화면은 같은 화면을 /main/cancel-ledger 로. 시안 Final2 ⑥ · FinalWeb2 상단 탭 '정산'.
// 월 이동(‹ minMonth 이전 · › 이번 달 이후 잠금) → 청구·입금·미수 3칸 → 표(날짜 · 차량·내역 · 금액, 첫 행 이전 잔액/전월미수)
// → [정산서 PDF] → 꼬리 문구. 데이터는 GET /my/cancel-ledger 단일 응답 그대로(routes/myCancelLedger.js) — 재가공 없음.
// 앱 정본: malso_ledger_screen.dart · malso_ledger_controller.dart(isLinkedOpening · canGoPrevLedgerMonth).
// 월 이동은 simple/parts/MonthNav 가 잠금을 받지 않아(≤768 은 월 시트) 화면 로컬로 둔다 — 같은 모양·같은 fmt 함수.
// 대행사(응답 isBroker — 비대행사·구 서버는 키 없음 = 현행 화면): 월 이동 아래 범위 칩 → 범위 시트(전체 / 거래처).
//   전체(scope all) = 3칸 + '거래처별 이번 달 청구' 표(byUnit 서버 순서 → 청구 없는 거래처 ₩0) + 청구·조정 행 거래처 라벨.
//   거래처(scope unit) = 청구 칸만 + 범위 안내 · [정산서 PDF] 는 그 거래처 청구 내역만(unitId).
//   시트 금액 = 보는 달의 '전체' 응답 — 거래처 범위에서 달을 바꿨으면 시트를 열 때 그 달 전체를 한 번 읽고, 읽는 중·실패면 금액을 숨긴다.
// props: { user, showToast }
import React, { useEffect, useState } from 'react';
import { T, R, FONT, S } from '../../theme';
import { useT, useLocale } from '../../../i18n/I18nProvider';
import { myCancelLedger, fetchMyCancelLedgerPdf, listMalsoClients } from '../api';
import { withKoJosa } from '../koJosa';
import { fmtKRW, isolate, monthLabel, shiftMonth, currentMonth } from '../../simple/fmt';
import { describeSimpleError } from '../../simple/errors';
import SimpleCard from '../../simple/parts/SimpleCard';
import LtrText from '../../simple/parts/LtrText';
import ErrorText from '../../simple/parts/ErrorText';
import { SheetFrame } from '../../simple/parts/ConfirmSheet';
import useGroupTabs from '../../kit/useGroupTabs';

var page = { display: 'flex', flexDirection: 'column', gap: 12, maxWidth: 720, width: '100%', margin: '0 auto' };
var headRow = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' };
var title = { fontSize: 19, fontWeight: 800, letterSpacing: '-.35px', color: T.navy, margin: 0 };

// MonthNav 데스크톱 모양 그대로 + 잠금(disabled) 상태
var navWrap = { display: 'inline-flex', alignItems: 'center', gap: 6 };
var arrow = { width: 30, height: 30, borderRadius: R.md, border: '1px solid ' + T.bd, background: T.card,
  color: T.body, cursor: 'pointer', fontFamily: 'inherit', fontSize: 14, lineHeight: 1 };
var arrowOff = Object.assign({}, arrow, { color: T.line, cursor: 'default' });
var navLabel = { fontSize: 13, fontWeight: 800, color: T.ink, minWidth: 96, textAlign: 'center' };

var sumRow = { display: 'flex', gap: 8 };
var sumCell = { flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 4, padding: '10px 12px',
  background: T.card, border: '1px solid ' + T.bd, borderRadius: R.card };
var sumOwed = Object.assign({}, sumCell, { background: T.warnTint, border: '1px solid ' + T.warnBd });
var sumLabel = { fontSize: FONT.label, fontWeight: 700, color: T.muted };
var sumValue = { fontSize: 17, fontWeight: 800, color: T.ink, letterSpacing: '-.3px', whiteSpace: 'nowrap' };

var table = { width: '100%', borderCollapse: 'collapse', fontSize: 12.5 };
var td = { padding: '9px 12px', borderBottom: '1px solid ' + T.bdSoft, color: T.ink, verticalAlign: 'top' };
var tdDate = Object.assign({}, td, { width: 52, color: T.muted, whiteSpace: 'nowrap' });
var tdAmt = Object.assign({}, td, { textAlign: 'end', fontWeight: 700, whiteSpace: 'nowrap' });
var openRow = { background: T.head };
var sub = { display: 'block', fontSize: 11.5, color: T.muted, marginTop: 2, wordBreak: 'keep-all' };   // '말소사실증명' 중간 끊김 방지
var pdfBtn = Object.assign({}, S.btn, { height: 40, width: '100%' });
var note = { fontSize: 11.5, color: T.faint, textAlign: 'center', padding: '4px 4px 10px' };

// 대행사 범위 칩·시트·거래처별 표 (시안 Ledger `.scope`·`.br`·`.cl2` · LedgerScope)
var scopeBtn = { display: 'flex', alignItems: 'center', gap: 8, width: '100%', padding: '10px 12px', borderRadius: R.lg,
  border: '1.5px solid ' + T.accent, background: T.accentTint, color: T.accentPress, fontSize: 14, fontWeight: 700,
  fontFamily: 'inherit', cursor: 'pointer', textAlign: 'start', boxSizing: 'border-box' };
var scopeItem = { display: 'flex', alignItems: 'center', gap: 12, width: '100%', padding: '11px 4px', border: 0,
  borderBottom: '1px solid ' + T.bdSoft, background: 'none', color: T.ink, fontFamily: 'inherit', textAlign: 'start', cursor: 'pointer' };
var indent = { width: 14, flex: 'none' };
var grow = { flex: 1, minWidth: 0 };
var radio = { width: 18, height: 18, borderRadius: '50%', border: '2px solid ' + T.line, boxSizing: 'border-box', flex: 'none' };
var radioOn = Object.assign({}, radio, { border: '5px solid ' + T.accent });
var itemName = { display: 'block', fontSize: 14, fontWeight: 700 };
var itemSub = { display: 'block', fontSize: 12, color: T.muted, marginTop: 2 };
var scopeNote = { fontSize: 12, color: T.sub, background: T.head, border: '1px solid ' + T.bd, borderRadius: R.md,
  padding: '10px 12px', lineHeight: 1.55 };
var buRow = { display: 'flex', justifyContent: 'space-between', gap: 10, padding: '8px 14px', borderTop: '1px solid ' + T.bdSoft, fontSize: 13 };
var buAmt = { fontWeight: 700, whiteSpace: 'nowrap' };
var buZero = Object.assign({}, buAmt, { color: T.faint, fontWeight: 400 });
var unitChip = { display: 'inline-block', marginInlineEnd: 6, padding: '0 6px', borderRadius: R.sm, background: T.accentTint,
  color: T.accentPress, fontWeight: 700 };

/// 음수는 U+2212 '−' + 절댓값 (시안 "−₩600,000").
function krw(v) { var n = Number(v) || 0; return n < 0 ? '−' + fmtKRW(-n) : fmtKRW(n); }

/// 'YYYY-MM-DD' → 'M/D' (빈 값 '-').
function ymdMd(ymd) {
  var m = /^\d{4}-(\d{2})-(\d{2})/.exec(String(ymd || ''));
  return m ? parseInt(m[1], 10) + '/' + parseInt(m[2], 10) : '-';
}

/// ISO(UTC) → 브라우저 로컬 'M/D'.
function isoMd(iso) {
  var d = new Date(iso || '');
  return isNaN(d.getTime()) ? '' : (d.getMonth() + 1) + '/' + d.getDate();
}

/// 첫 행이 "이전 잔액(연결일 기준)" 인지 — 연결 월이고 연결 후 이월이 없을 때만. 앱 isLinkedOpening · 서버 PDF 라벨과 같은 규칙.
function isLinkedOpening(d) {
  return !!d.minMonth && d.month === d.minMonth && !!d.linkedAt && Number(d.opening) === Number(d.linkedBalance);
}

function carOf(r) { return [r.carNo, r.carType].filter(Boolean).join(' '); }

function MalsoLedger(props) {
  var t = useT();
  var loc = useLocale();
  var st1 = useState(currentMonth()); var ym = st1[0], setYm = st1[1];
  var st2 = useState(null); var data = st2[0], setData = st2[1];
  var st3 = useState(null); var error = st3[0], setError = st3[1];
  var st4 = useState(false); var busy = st4[0], setBusy = st4[1];
  var st5 = useState(0); var unitId = st5[0], setUnitId = st5[1];          // 대행사 범위 — 0 = 전체
  var st6 = useState(null); var clients = st6[0], setClients = st6[1];     // listMalsoClients (대행사일 때만 읽는다)
  var st7 = useState(null); var allData = st7[0], setAllData = st7[1];     // 마지막 '전체' 응답 — 범위 시트 금액
  var st8 = useState(false); var scopeOpen = st8[0], setScopeOpen = st8[1];
  var fresh = !!allData && allData.month === ym;   // 시트 금액이 보는 달 것인지
  // 전체 화면(/main/cancel-ledger)에서만 차량 묶음 헤더 탭을 그린다 — 말소 셸 경로에선 null.
  var groupTabs = useGroupTabs('cars', 'cancel-ledger');

  useEffect(function () {
    var alive = true;
    setError(null);
    var params = { month: ym };
    if (unitId) params.unitId = unitId;   // 0 을 넘기면 ?unitId=0 이 붙는다(api query 는 0 을 거르지 않음)
    myCancelLedger(params).then(function (body) {
      if (!alive) return;
      setData(body || {});
      if (body && body.isBroker && body.scope !== 'unit') setAllData(body);
    }).catch(function (err) {
      if (alive) setError(err);
    });
    return function () { alive = false; };
  }, [ym, unitId, setData, setError, setAllData]);

  var broker = !!(data && data.isBroker);
  useEffect(function () {
    if (!broker) return undefined;
    var alive = true;
    listMalsoClients().then(function (c) { if (alive && c && c.isBroker) setClients(c); })
      .catch(function () { /* 거래처 이름 없이 byUnit 만으로 그린다 */ });
    return function () { alive = false; };
  }, [broker, setClients]);

  // 로딩 전엔 minMonth 를 몰라 ‹ 잠금(앱과 동일). minMonth '' = 연결 경계 없음 → 잠금 없음.
  var prevOk = !!data && (!data.minMonth || ym > data.minMonth);
  var nextOk = ym < currentMonth();   // 미래 월 없음(앱과 동일)

  var onPdf = function () {
    if (busy) return;
    setBusy(true);
    var pdfUnit = data && data.scope === 'unit' ? Number(data.unitId) || 0 : 0;
    (pdfUnit ? fetchMyCancelLedgerPdf(ym, pdfUnit) : fetchMyCancelLedgerPdf(ym)).then(function (res) {
      if (!res || !res.ok) throw new Error('');
      // 서버 파일명(Content-Disposition, server.js cors exposedHeaders) 우선 — 못 읽으면 같은 규칙에서 업체명만 뺀다(앱과 동일)
      var m = /filename="([^"]+)"/.exec((res.headers && res.headers.get && res.headers.get('Content-Disposition')) || '');
      var name = monthLabel('ko', ym) + ' 말소대행정산서.pdf';
      if (m) { try { name = decodeURIComponent(m[1]); } catch (e) { /* 깨진 인코딩 — 위 이름으로 저장 */ } }
      return res.blob().then(function (b) { return { blob: b, name: name }; });
    }).then(function (x) {
      var u = URL.createObjectURL(x.blob);
      var a = document.createElement('a'); a.href = u; a.download = x.name; document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(u); }, 60000);
    }).catch(function () {
      if (props.showToast) props.showToast(t('malsoModeLedgerPdfFailed'), 'err');
    }).then(function () { setBusy(false); });
  };

  function line(key, date, main, subText, amount, color, style) {
    var c = color ? { color: color } : null;
    return (<tr key={key} data-testid={'malso-ledger-row-' + key} style={style}>
      <td style={tdDate}><LtrText>{date}</LtrText></td>
      <td style={c ? Object.assign({}, td, c, { fontWeight: 600 }) : td}>
        {main}{subText ? <span style={sub}>{subText}</span> : null}
      </td>
      <td style={c ? Object.assign({}, tdAmt, c) : tdAmt}><LtrText>{amount}</LtrText></td>
    </tr>);
  }

  // 대행사 이름 표기 — 본인 몫 = '{name} (본인)', 계정 공통(unitName '') = '계정 공통'.
  var unitScope = broker && data.scope === 'unit';
  var picks = (clients && clients.clients) || [];
  var byUnitAll = (allData && allData.byUnit) || [];
  var selfRow = byUnitAll.filter(function (u) { return u.isSelf; })[0];
  var accountName = (clients && clients.accountName) || (selfRow ? selfRow.unitName : '');
  var selfName = function (name) { return t('malsoModeBrokerSelfName', { name: name }); };
  var nameOfUnit = function (name) { return !name ? t('malsoModeBrokerAccountCommon') : name === accountName ? selfName(name) : name; };
  var pickName = function (c) { return c.isSelf ? selfName(c.name) : c.name; };

  var openScope = function () {
    setScopeOpen(true);
    if (fresh) return;
    var month = ym;
    myCancelLedger({ month: month }).then(function (body) {
      if (body && body.isBroker && body.scope !== 'unit' && body.month === month) setAllData(body);
    }).catch(function () { /* 금액 숨김 그대로 */ });
  };

  function withTag(r, text) {
    if (!broker || unitScope) return text;
    return <React.Fragment><span style={unitChip}>{nameOfUnit(r.unitName || '')}</span>{text}</React.Fragment>;
  }

  function rowOf(r) {
    if (r.kind === 'payment') return line(r.id, ymdMd(r.date), t('ledgerKindPayment'), '', '−' + fmtKRW(Math.abs(Number(r.amount) || 0)), T.ok);
    if (r.kind === 'charge') {
      var desc = [r.jobKind, r.cancelReason, r.extraServiceNote].filter(Boolean).join(' · ');
      return line(r.id, ymdMd(r.date), <LtrText>{carOf(r) || '-'}</LtrText>, withTag(r, desc), krw(r.amount));
    }
    return line(r.id, ymdMd(r.date), t('malsoModeLedgerAdjust'), withTag(r, carOf(r)), krw(r.amount));
  }

  // 거래처별 이번 달 청구 — 본인 몫 맨 위(청구 0 이어도) → byUnit 서버 순서(이름순, 계정 공통 unitId 0) → 청구 없는 거래처 ₩0.
  function byUnitCard() {
    var by = data.byUnit || [];
    var all = by.map(function (u) {
      return { id: u.unitId, self: !!u.isSelf, name: u.isSelf ? selfName(u.unitName) : nameOfUnit(u.unitName), charged: Number(u.charged) || 0 };
    }).concat(picks.filter(function (c) { return !by.some(function (u) { return u.unitId === c.id; }); })
      .map(function (c) { return { id: c.id, self: !!c.isSelf, name: pickName(c), charged: 0 }; }));
    var list = all.filter(function (u) { return u.self; }).concat(all.filter(function (u) { return !u.self; }));
    return (<SimpleCard title={t('malsoModeBrokerByUnitTitle')}>
      {list.map(function (u) {
        return (<div key={u.id} data-testid={'malso-byunit-' + u.id} style={buRow}>
          <span>{u.name}</span><LtrText style={u.charged ? buAmt : buZero}>{krw(u.charged)}</LtrText>
        </div>);
      })}
    </SimpleCard>);
  }

  var body = null;
  if (!error && !data) body = <div style={S.emptyText}>{t('commonLoading')}</div>;
  else if (!error && !data.agency) body = <SimpleCard><div style={S.emptyText}>{t('malsoModeLedgerEmpty')}</div></SimpleCard>;
  else if (!error) {
    var mm = parseInt(String(data.month || ym).slice(5), 10) || 0;
    var openLabel = isLinkedOpening(data)
      ? t('malsoModeLedgerOpeningLinked', { date: isolate(isoMd(data.linkedAt)) }) : t('ledgerFlowOpening');
    var rows = data.rows || [];
    body = (<React.Fragment>
      <div style={sumRow}>
        <div style={sumCell}><span style={sumLabel}>{t('ledgerKindCharge')}</span><LtrText style={sumValue}>{krw(data.charged)}</LtrText></div>
        {unitScope ? null : (<React.Fragment>
          <div style={sumCell}><span style={sumLabel}>{t('ledgerKindPayment')}</span><LtrText style={Object.assign({}, sumValue, { color: T.ok })}>{krw(data.paid)}</LtrText></div>
          <div style={sumOwed} data-testid="malso-ledger-closing"><span style={Object.assign({}, sumLabel, { color: T.warn })}>{t('settleReceivableOutstanding')}</span>
            <LtrText style={Object.assign({}, sumValue, { color: T.warn })}>{krw(data.closing)}</LtrText></div>
        </React.Fragment>)}
      </div>
      {unitScope ? <div style={scopeNote} data-testid="malso-scope-note">{t('malsoModeBrokerScopeNote')}</div> : null}
      {broker && !unitScope ? byUnitCard() : null}
      {unitScope && !rows.length ? <SimpleCard><div style={S.emptyText}>{t('malsoModeBrokerScopeUnitNone')}</div></SimpleCard> : (<SimpleCard>
        <table style={table}>
          <tbody>
            {unitScope ? null : line('opening', mm + '/1', openLabel, '', krw(data.opening), T.muted, openRow)}
            {rows.map(rowOf)}
          </tbody>
        </table>
      </SimpleCard>)}
      {/* 정산서는 대행사가 그 달을 발행한 뒤에만 — 발행본 그대로 (Jin 10/29) */}
      {data.statement ? <button type="button" style={pdfBtn} disabled={busy} onClick={onPdf}>{t('settleActionPdf')}</button>
        : <div style={note} data-testid="malso-ledger-pdf-after-issue">{broker
          ? t('malsoModeBrokerLedgerPdfAfterIssue', { agency: withKoJosa(loc.locale, data.agency.name || '', '이', '가') })
          : t('malsoModeLedgerPdfAfterIssue')}</div>}
      {data.minMonth ? <div style={note}>{t('malsoModeLedgerSinceLinked', { agency: data.agency.name, date: isolate(isoMd(data.linkedAt)) })}</div> : null}
    </React.Fragment>);
  }

  return (<div className="ss-ledger" style={page}>
    {groupTabs}
    <div style={headRow}>
      <h2 style={title}>{t('malsoModeTabLedger')}</h2>
      <span className="ss-monthnav" style={navWrap}>
        <button type="button" className="ss-flipx" data-testid="malso-ledger-prev" style={prevOk ? arrow : arrowOff} disabled={!prevOk}
          aria-label={monthLabel(loc.locale, shiftMonth(ym, -1))} onClick={function () { setYm(shiftMonth(ym, -1)); }}>‹</button>
        <span style={navLabel}>{monthLabel(loc.locale, ym)}</span>
        <button type="button" className="ss-flipx" data-testid="malso-ledger-next" style={nextOk ? arrow : arrowOff} disabled={!nextOk}
          aria-label={monthLabel(loc.locale, shiftMonth(ym, 1))} onClick={function () { setYm(shiftMonth(ym, 1)); }}>›</button>
      </span>
    </div>
    {broker ? (<button type="button" data-testid="malso-scope" style={scopeBtn} onClick={openScope}>
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true" focusable="false">
        <path d="M4 21V8l8-5 8 5v13M9 21v-6h6v6" /></svg>
      <span style={grow}>{unitId
        ? picks.filter(function (c) { return c.id === unitId; }).map(pickName)[0] || ''
        : t('malsoModeBrokerScopeAll', { name: accountName, count: picks.filter(function (c) { return !c.isSelf; }).length })}</span>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" aria-hidden="true" focusable="false">
        <path d="M6 9l6 6 6-6" /></svg>
    </button>) : null}
    {error ? <ErrorText>{describeSimpleError(t, error)}</ErrorText> : null}
    {body}
    <SheetFrame open={broker && scopeOpen} title={t('malsoModeBrokerScopeTitle')} closeLabel={t('actionClose')}
      onClose={function () { setScopeOpen(false); }}>
      <div>
        {[{ id: 0 }].concat(picks).map(function (c) {
          var u = byUnitAll.filter(function (x) { return x.unitId === c.id; })[0];
          var charged = u ? Number(u.charged) || 0 : 0;
          var sub = !fresh ? '' : !c.id
            ? t('malsoModeBrokerScopeAllSub', { name: withKoJosa(loc.locale, accountName, '과', '와'),
              count: picks.filter(function (x) { return !x.isSelf; }).length, amount: isolate(krw(allData.closing)) })
            : charged ? t('malsoModeBrokerScopeUnitSub', { amount: isolate(krw(charged)) }) : t('malsoModeBrokerScopeUnitNone');
          return (<button key={c.id} type="button" data-testid={'malso-scope-' + c.id} style={scopeItem}
            onClick={function () { setScopeOpen(false); setUnitId(c.id); }}>
            {c.id ? <span style={indent} /> : null}
            <span style={c.id === unitId ? radioOn : radio} />
            <span style={grow}>
              <span style={itemName}>{c.id ? pickName(c) : t('cancelHistoryMonthAll')}</span>
              {sub ? <span style={itemSub}>{sub}</span> : null}
            </span>
          </button>);
        })}
      </div>
      <div style={scopeNote}>{t('malsoModeBrokerScopeNote')}</div>
    </SheetFrame>
  </div>);
}

export default MalsoLedger;
